// 财务报表信息
<template>
    <div class="main">
        <el-row :gutter="10" class="mar_tb">
            <el-col :span="24">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <i class="icon iconfont icon-danju-xiugai-tianchong" style="margin-right:2px;"></i>
                        <span style="font-size:13px;">财务报表</span>
                    </div>
                    <div class="search-content mar_b" style="margin-bottom:-15px;">
                        <el-form :inline="true" label-width="180px" size="mini" 
                            :model="query" class="demo-form-inline" ref="query">
                            <el-form-item prop="data_date" label="日期：">
                                <el-date-picker style="width:180px;" v-model="query.data_date" type="date" placeholder="日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
                            </el-form-item>
                            <el-form-item class="search-but" style="float:right;margin-right:600px">
                                <el-button type="primary" @click="selectList">查询报表数据</el-button>
                                <el-button type="success" @click="selectHZList">查询汇总数据</el-button>
                                <el-button @click="resetForm('query')">重置</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="10" class="mar_tb" sytle="height:30px">
            <el-col :span="24">
                <el-card class="box-card">
                    <div class="text e-info auto-table">
                        <!--<el-button type="primary" @click="selectCertno" size="small" :disabled="isAble">获取证书号</el-button>
                        <el-button type="primary" @click="exportSelect" :disabled="isAble" size="small">导出选中</el-button>
                        <el-button type="primary" @click="exportAll" size="small">导出全部</el-button>-->
                        <el-button type="success" @click="dialogTableVisible = true" size="small">新增项目</el-button>
                        <el-button type="primary" @click="updateFinanceReport" size="small">更新报表数据</el-button>
                        <el-button type="primary" @click="updateFinanceCount" size="small">更新汇总数据</el-button>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="10" class="mar_tb" sytle="height:30px">
            <el-col :span="24">
                <el-card class="box-card">
                    <div class="text e-info auto-table">
                        <el-table :data="financialReportInfoList" border 
                            ref="refTable" stripe size="mini"
                            :header-cell-style="{background:'#eef1f6',color:'#606266'}">
                            <!--<el-table-column type="selection" align="center" width="40"></el-table-column>-->
                            <el-table-column align="center" min-width="120" prop="type" label="">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.type=='财务费用' || scope.row.type=='管理费用' || scope.row.type=='销售费用' || scope.row.type=='净利润'" style="font-weight: bold;text-align: left;display: block;">{{ scope.row.type }}</span>
                                    <span v-else >{{ scope.row.type }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" min-width="100" prop="feb" label="2月"></el-table-column>
                            <el-table-column align="center" min-width="100" prop="mar" label="3月"></el-table-column>
                            <el-table-column align="center" min-width="100" prop="apr" label="4月"></el-table-column>
                            <el-table-column align="center" min-width="100" prop="may" label="5月"></el-table-column>
                            <el-table-column align="center" min-width="100" prop="june" label="6月"></el-table-column>
                            <el-table-column align="center" min-width="100" prop="july" label="7月"></el-table-column>
                            <el-table-column align="center" min-width="100" prop="aug" label="8月"></el-table-column>
                            <el-table-column align="center" min-width="100" prop="sep" label="9月"></el-table-column>
                            <el-table-column align="center" min-width="100" prop="oct" label="10月"></el-table-column>
                            <el-table-column align="center" min-width="100" prop="nov" label="11月"></el-table-column>
                            <el-table-column align="center" min-width="100" prop="dec" label="12月"></el-table-column>
                            <el-table-column align="center" min-width="100" prop="jan" label="1月"></el-table-column>
                        </el-table>
                    </div>
                    <!--分页
                    <div class="block tar mar_t">
                        <div class="text e-info auto-table">
                            <span style='float:left;font-size:18px'> 已选：{{data_len}} </span>
                        </div>
                        <el-pagination @size-change="sizeChange" @current-change="pageChange" :current-page="pager.page"
                                       :page-sizes="[20, 50, 100, 200]" :page-size="pager.rows"
                                       layout="total,sizes, prev, pager, next, jumper"
                                       :total="pager.total"></el-pagination>
                    </div>
                    -->
                </el-card>
            </el-col>
            <div class="text e-info auto-table">
                <el-dialog title="编辑信息" :visible.sync = "dialogTableVisible" @close="closeSava" 
                    center :close-on-click-modal="false" width="400px">
                    <el-form :inline="true" label-width="110px" size="mini" :model="addDataForm" 
                            class="demo-form-inline" ref="addDataForm" :rules="rules">
                        <el-form-item prop="canshu" label="项目：">
                            <el-select v-model="addDataForm.canshu" placeholder="请选择" clearable>
                                <el-option v-for="item in dictList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="amount" label="数额：">
                            <el-input style="width:180px;" v-model="addDataForm.amount" placeholder="请输入" oninput="value=value.replace(/[^-0-9.]/g,'')"></el-input>
                        </el-form-item>
                        <el-form-item prop="data_date" label="日期：">
                            <el-date-picker style="width:180px;" v-model="addDataForm.data_date" type="date" placeholder="日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
                        </el-form-item>
                        <!--
                        <el-form-item prop="remark" label="备注：">
                            <el-input type="textarea" :autosize="{minRows:6, maxRows:3}" style="width:500px;"
                                placeholder="请输入内容" v-model="addDataForm.remark">
                            </el-input>
                        </el-form-item><br>-->
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button type="primary" @click="closeSava">取 消</el-button>
                        <el-button type="primary" @click="savaInfo">保存并提交</el-button>
                    </div>
                </el-dialog>
            </div>
            <div class="text e-info auto-table">
                <el-dialog title="汇总信息" :visible.sync = "dialogTableVisible2" @close="closeSava1" 
                    center :close-on-click-modal="false" width="1600px">
                    <el-table :data="financialHZInfoList" border 
                        ref="refTable" stripe size="mini"
                        :header-cell-style="{background:'#eef1f6',color:'#606266'}">
                        <!--<el-table-column type="selection" align="center" width="40"></el-table-column>-->
                        <el-table-column align="center" min-width="120" prop="type" label="项目"></el-table-column>
                        <el-table-column align="center" min-width="100" prop="feb" label="2月"></el-table-column>
                        <el-table-column align="center" min-width="100" prop="mar" label="3月"></el-table-column>
                        <el-table-column align="center" min-width="100" prop="apr" label="4月"></el-table-column>
                        <el-table-column align="center" min-width="100" prop="may" label="5月"></el-table-column>
                        <el-table-column align="center" min-width="100" prop="june" label="6月"></el-table-column>
                        <el-table-column align="center" min-width="100" prop="july" label="7月"></el-table-column>
                        <el-table-column align="center" min-width="100" prop="aug" label="8月"></el-table-column>
                        <el-table-column align="center" min-width="100" prop="sep" label="9月"></el-table-column>
                        <el-table-column align="center" min-width="100" prop="oct" label="10月"></el-table-column>
                        <el-table-column align="center" min-width="100" prop="nov" label="11月"></el-table-column>
                        <el-table-column align="center" min-width="100" prop="dec" label="12月"></el-table-column>
                        <el-table-column align="center" min-width="100" prop="jan" label="1月"></el-table-column>
                    </el-table>
                </el-dialog>
            </div>
        </el-row>
    </div>
</template>
<script>
    import util from '../../common/js/util.js';
    export default {
        data() {
            return {
                isAble: true,
                dictList: [],
                dictHZList: [],
                dialogTableVisible: false,
                dialogTableVisible2: false,
                addDataForm: {},
                dataOnLineListSelections: [],
                certnoList: [],
                certnoStr: '',
                financialReportInfoList: [],
                financialHZInfoList: [],
                financialInfoAllList: [],
                data_len: 0,
                // 查询
                query: {
                    data_dt: [],
                },
                queryDate: '',
                // queryDate: this.getNowTime(),
                // 分页
                pager: {
                    page: 1,
                    rows: 20,
                    total: 0
                },
                rules: {
                    canshu: [
                        {
                            required: true,
                            message: '请选择项目',
                            trigger: 'blur'
                        }
                    ],
                    amount: [
                        {
                            required: true,
                            message: '请输入数额',
                            trigger: 'blur'
                        }
                    ],
                    data_date: [
                        {
                            required: true,
                            message: '请输入日期',
                            trigger: 'blur'
                        }
                    ],
                }
            };
        },
        methods: {
            // 选择行数
            sizeChange(rows) {
                this.pager.rows = rows;
                this.selectList();
            },
            // 选择页
            pageChange(page) {
                this.pager.page = page;
                this.selectList();
            },
            // 选择器选择数据，加工数据证书号
            selectionLineChangeHandle(val) {
                // 统计选中数量
                this.data_len = val.length;
                // 选中导出数据赋值
                this.dataOnLineListSelections = val;
                // id、数据证书号拼接
                this.idList = val.map((item) => item.id);
                this.certnoList = val.map((item) => item.cert_no + '\n');
                //数据选中后，显示按钮
                if(val.length>0) {
                    this.isAble = false;
                }else{
                    this.isAble = true;
                }
            },
            // 获取证书号
            selectCertno() {
                this.certnoStr = this.certnoList.join(',');
                this.certnoStr = this.certnoStr.replaceAll(',','');
                // this.dialogTableVisible = true;
                // 复制
                this.copyText(this.certnoStr);
            },
            copyText(val){
                // 存储传递过来的数据
                //let userId = sessionStorage.getItem("userId");
                // createElement() 方法通过指定名称创建一个元素
                let newInput = document.createElement('textarea');
                // 讲存储的数据赋值给input的value值
                newInput.value = val;
                // appendChild() 方法向节点添加最后一个子节点
                document.body.appendChild(newInput);
                // select() 方法用于选择该元素中的文本
                newInput.select();
                // execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
                document.execCommand('Copy');
                // 清空输入框
                newInput.remove();
                // 下面是element的弹窗 不需要的自行删除就好
                this.$message({
                    message: "复制成功",
                    type: "success",
                });
            },
            // 查询数据字典 地点
            selectDictList() {
                let _this = this;
                util.publicget('/diamond/queryDaimondDictList', {
                    equalsParam: '报表参数'
                }, function (res) {
                    if (res.flag) {
                        // console.log(res.obj);
                        _this.dictList = res.obj;
                        // _this.selectList();
                    } else {
                        _this.errorMsg("操作异常！");
                    }
                });
            },
            // 查询数据字典 地点
            selectHZDictList() {
                let _this = this;
                util.publicget('/diamond/queryDaimondDictList', {
                    equalsParam: '汇总参数'
                }, function (res) {
                    if (res.flag) {
                        // console.log(res.obj);
                        _this.dictHZList = res.obj;
                        // _this.selectList();
                    } else {
                        _this.errorMsg("操作异常！");
                    }
                });
            },
            // 新增财务报表记录数据
            savaInfo() {
                let _this = this;
                // 判断表单是否通过了表单验证
                this.$refs.addDataForm.validate((valid) => {
                    if (valid) { // 通过了则将数据返回后台
                        util.publicget('/financial/savaFinanceReportInfo', {
                            // user: document.cookie.split(';')[1].split('=')[1],
                            user: sessionStorage.getItem('userName'),
                            canshu: _this.addDataForm.canshu,
                            amount: _this.addDataForm.amount,
                            data_date: _this.addDataForm.data_date
                        }, function (res) {
                            if (res.flag) {
                                _this.successMsg('操作成功！');
                                _this.dialogTableVisible = false;
                                // _this.selectList();
                            } else {
                                _this.errorMsg(res.msg);
                            }
                        });
                    } else { // 否则返回
                        return false;
                    }
                });
            },
            // 更新报表
            updateFinanceReport(){
                let _this = this;
                util.publicget('/financial/updateFinanceReport', {
                    // user: document.cookie.split(';')[1].split('=')[1],
                    user: sessionStorage.getItem('userName'),
                    data_date: _this.query.data_date
                }, function (res) {
                    if (res.flag) {
                        _this.successMsg('操作成功！');
                        _this.selectList();
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 生成汇总数据
            updateFinanceCount(){
                let _this = this;
                util.publicget('/financial/updateFinanceCount', {
                    // user: document.cookie.split(';')[1].split('=')[1],
                    user: sessionStorage.getItem('userName'),
                    data_date: _this.query.data_date
                }, function (res) {
                    if (res.flag) {
                        _this.successMsg('操作成功！');
                        _this.selectHZList();
                        _this.dialogTableVisible2 = true;
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 加载财务报表信息
            selectList() {
                let _this = this;
                _this.selectDictList();
                util.publicget('/financial/queryFinanceReportList', {
                    user: sessionStorage.getItem('userName'),
                    project: "F",
                    data_date: _this.query.data_date
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        _this.pager.total = res.count || 0;
                        //_this.financialReportInfoList = res.obj;
                        if(res.obj){
                            /*
                            // 生成第一列参数
                            let array = res.obj.map(item => {
                                return item.param
                            })
                            array = array.filter(function(item, index, arr){
                                return arr.indexOf(item) === index;
                            })
                            console.log(array)
                            */
                            let newList = []
                            for(let a = 0; a<_this.dictList.length; a++){
                                let map1 = {}
                                //console.log(_this.dictList[a].value)
                                map1['type'] = _this.dictList[a].value;
                                newList.push(map1)
                            }
                            //给每个对象的data追加数据
                            res.obj.forEach((item, index) => {
                                for(let i in newList) {
                                    if(item.param == newList[i].type && item.month == 2) {
                                        newList[i].feb = item.value
                                    }else if(item.param == newList[i].type && item.month == 3) {
                                        newList[i].mar = item.value
                                    }else if(item.param == newList[i].type && item.month == 4) {
                                        newList[i].apr = item.value
                                    }else if(item.param == newList[i].type && item.month == 5) {
                                        newList[i].may = item.value
                                    }else if(item.param == newList[i].type && item.month == 6) {
                                        newList[i].june = item.value
                                    }else if(item.param == newList[i].type && item.month == 7) {
                                        newList[i].july = item.value
                                    }else if(item.param == newList[i].type && item.month == 8) {
                                        newList[i].aug = item.value
                                    }else if(item.param == newList[i].type && item.month == 9) {
                                        newList[i].sep = item.value
                                    }else if(item.param == newList[i].type && item.month == 10) {
                                        newList[i].oct = item.value
                                    }else if(item.param == newList[i].type && item.month == 11) {
                                        newList[i].nov = item.value
                                    }else if(item.param == newList[i].type && item.month == 12) {
                                        newList[i].dec = item.value
                                    }else if(item.param == newList[i].type && item.month == 1) {
                                        newList[i].jan = item.value
                                    }
                                }
                            })
                            _this.financialReportInfoList = newList;
                            // console.log(newList);
                        }
                    } else {
                        _this.errorMsg('本次操作失败');
                    }
                });
            },
            // 加载财务汇总信息
            selectHZList() {
                let _this = this;
                _this.selectHZDictList();
                _this.dialogTableVisible2 = true;
                util.publicget('/financial/queryFinanceReportList', {
                    user: sessionStorage.getItem('userName'),
                    project: "S",
                    data_date: _this.query.data_date
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        _this.pager.total = res.count || 0;
                        //_this.financialReportInfoList = res.obj;
                        if(res.obj){
                            /*
                            // 生成第一列参数
                            let array = res.obj.map(item => {
                                return item.param
                            })
                            array = array.filter(function(item, index, arr){
                                return arr.indexOf(item) === index;
                            })
                            console.log(array)
                            */
                            let newList = []
                            for(let a = 0; a<_this.dictHZList.length; a++){
                                let map1 = {}
                                //console.log(_this.dictHZList[a].value)
                                map1['type'] = _this.dictHZList[a].value;
                                newList.push(map1)
                            }
                            //给每个对象的data追加数据
                            res.obj.forEach((item, index) => {
                                for(let i in newList) {
                                    if(item.param == newList[i].type && item.month == 2) {
                                        newList[i].feb = item.value
                                    }else if(item.param == newList[i].type && item.month == 3) {
                                        newList[i].mar = item.value
                                    }else if(item.param == newList[i].type && item.month == 4) {
                                        newList[i].apr = item.value
                                    }else if(item.param == newList[i].type && item.month == 5) {
                                        newList[i].may = item.value
                                    }else if(item.param == newList[i].type && item.month == 6) {
                                        newList[i].june = item.value
                                    }else if(item.param == newList[i].type && item.month == 7) {
                                        newList[i].july = item.value
                                    }else if(item.param == newList[i].type && item.month == 8) {
                                        newList[i].aug = item.value
                                    }else if(item.param == newList[i].type && item.month == 9) {
                                        newList[i].sep = item.value
                                    }else if(item.param == newList[i].type && item.month == 10) {
                                        newList[i].oct = item.value
                                    }else if(item.param == newList[i].type && item.month == 11) {
                                        newList[i].nov = item.value
                                    }else if(item.param == newList[i].type && item.month == 12) {
                                        newList[i].dec = item.value
                                    }else if(item.param == newList[i].type && item.month == 1) {
                                        newList[i].jan = item.value
                                    }
                                }
                            })
                            _this.financialHZInfoList = newList;
                            // console.log(newList);
                        }
                    } else {
                        _this.errorMsg('本次操作失败');
                    }
                });
            },
            // 加载查询订单单条记录
            selectSavaList(rows) {
                let _this = this;
                util.publicget('/financial/queryFinancialList', {
                    equalsId: rows.id,
                    equalsCert_no: rows.cert_no
                }, function (res) {
                    if (res.flag) {
                        // console.log(res.obj);
                        if(res.obj.length>0) {
                            _this.addDataForm = res.obj[0];
                            _this.dialogTableVisible10 = true;
                        }else {
                            _this.showMsg("该证书号数据不存在");
                        }
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // dialog 关闭，数据清空
            closeSava() {
                this.dialogTableVisible = false;
                this.addDataForm = {};
                this.selectList();
            },
            closeSava1() {
                this.dialogTableVisible2 = false;
            },
            // 取消
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.query = {};
            },
            // 前端处理 导出选中数据
            exportSelect() {
                //let res =[{name:'小白',age:'18'},{name:'小黑',age:'16'}]
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../../common/js/Export2Excel.js')
                    const tHeader = ['证书号','客户名称','货品状态', '记账日期', '到账日期'
                            , '成本rap', '成本折扣', '货品成本', '综合费点', '美金成本', '人民币成本'
                            , '销售美金', '销售汇率', '售价', '实收', '利润', '应收利润率'
                            , '备注', '业务员', '数据日期']
                    const filterVal = ['cert_no','clients','diamond_status', 'account_date', 'arrived_date'
                            ,'cost_rap', 'cost_dis', 'cost', 'point', 'usd_cost', 'rmb_cost'
                            , 'sale_usd', 'sale_rate', 'sale_price', 'paid', 'income', 'profit_rate'
                            , 'remark' , 'create_user', 'data_date' ]
                    const list = this.dataOnLineListSelections
                    const data = this.formatJson(filterVal, list)
                    export_json_to_excel(tHeader, data, '财务信息')
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            // 导出全部数据
            exportAll() {
                this.selectAllList();
                //let res =[{name:'小白',age:'18'},{name:'小黑',age:'16'}]
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../../common/js/Export2Excel.js')
                    const tHeader = ['证书号','客户名称','货品状态', '记账日期', '到账日期'
                            , '成本rap', '成本折扣', '货品成本', '综合费点', '美金成本', '人民币成本'
                            , '销售美金', '销售汇率', '售价', '实收', '利润', '应收利润率'
                            , '备注', '业务员', '数据日期']
                    const filterVal = ['cert_no','clients','diamond_status', 'account_date', 'arrived_date'
                            ,'cost_rap', 'cost_dis', 'cost', 'point', 'usd_cost', 'rmb_cost'
                            , 'sale_usd', 'sale_rate', 'sale_price', 'paid', 'income', 'profit_rate'
                            , 'remark' , 'create_user', 'data_date' ]
                    const list = this.financialInfoAllList
                    const data = this.formatJson(filterVal, list)
                    export_json_to_excel(tHeader, data, '全部财务信息')
                })
            },
            // 时间格式化
            formatterDate(row, column) {
                return util.formatDate.format(new Date(row.start_date), 'yyyy-MM-dd');
            },
            getNowTime() {
                var now = new Date();
                var year = now.getFullYear();
                var month = now.getMonth();
                var date = now.getDate();
                month = month + 1;
                month = month.toString().padStart(2, '0');
                date = date.toString().padStart(2, '0');
                var defaultDate = `${year}-${month}-${date}`;
                return defaultDate;
            }
        },
        mounted() {
            this.selectDictList();
            this.selectHZDictList();
            //this.selectList();
        }
    };
</script>

<style lang="scss">
    /*
    ::v-deep .el-table__expand-icon {
        display: none !important;
    }*/
    .el-dialog .el-dialog__body{
        flex: 1;
        overflow: auto;
    }
     /*:header-cell-style="{background:'#eee8aa'}"
    .el-table--border:after,
    .el-table--group:after,
    .el-table:before{
        background-color: #eee8aa
    }

    .el-table--border,
    .el-table--group{
        border-color: #eee8aa
    }

    .el-table td,
    .el-table th.is-leaf{
        border-bottom: #eee8aa
    }

    .el-table--border th,
    .el-table--border th.gutter:last-of-type{
        border-bottom: #eee8aa
    }

    .el-table--border td,
    .el-table--border th{
        border-right: #eee8aa
    }
    */
</style>



// WEBPACK FOOTER //
// src/pages/procurement/financialReportInfoList.vue